import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import AnnouncementBar from './components/AnnouncementBar';
import Footer from './components/Footer';
import Home from './pages/Home';
import PaymentReturn from './pages/PaymentReturn';

export default function App() {
  return (
    <div className="site">
      <AnnouncementBar />
      <Header />
      <main className="site-main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/payment/return" element={<PaymentReturn />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
